export default __webpack_public_path__ + "static/media/cpThaiReferralBanner.69917079.jpg";